import React, { useState } from 'react'

import { DialogContent, MenuItem, TextField } from '@material-ui/core'

import { QrReader } from 'react-qr-reader'
import { Modal } from 'asterX-UI/Modals'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'

const QrScanner = ({ open, onClose, onSuccess, isDesk = false }) => {
  const [mode, setMode] = useState('user')

  const handleChangeMode = e => setMode(e.target.value)

  const handleClose = () => {
    onClose && onClose()
  }
  const handleScan = (result, error) => {
    if (!!result) {
      onSuccess && onSuccess(result.text)
      handleClose()
    }
    if (!!error) {
      console.info(error)
    }
  }
  return (
    <Modal open={open} onClose={onClose} fullScreen={!isDesk} fullWidth>
      <ModalTitle onClose={onClose}>Сканирование QR-кода</ModalTitle>
      <DialogContent>
        <div>
          <div>
            <TextField
              value={mode}
              label={'Выбор камеры'}
              onChange={handleChangeMode}
              select
              fullWidth
            >
              <MenuItem value="environment">1</MenuItem>
              <MenuItem value="user">2</MenuItem>
            </TextField>
          </div>

          <div
            style={{
              width: '100%'
            }}
          >
            <QrReader
              ViewFinder={ViewFinder}
              delay={200}
              onResult={handleScan}
              constraints={{ facingMode: mode }}
            />
          </div>
        </div>
      </DialogContent>
    </Modal>
  )
}
export default QrScanner
const ViewFinder = props => (
  <>
    <svg
      width="50px"
      viewBox="0 0 100 100"
      style={{
        top: 0,
        left: 0,
        zIndex: 1,
        boxSizing: 'border-box',
        border: '50px solid rgba(0, 0, 0, 0.3)',
        position: 'absolute',
        width: '100%',
        height: '100%'
      }}
    >
      <path
        fill="none"
        d="M13,0 L0,0 L0,13"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
      <path
        fill="none"
        d="M0,87 L0,100 L13,100"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
      <path
        fill="none"
        d="M87,100 L100,100 L100,87"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
      <path
        fill="none"
        d="M100,13 L100,0 87,0"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
    </svg>
  </>
)
